import { render, staticRenderFns } from "./AdminQueueHealth.vue?vue&type=template&id=67f88278&scoped=true&"
import script from "./AdminQueueHealth.vue?vue&type=script&lang=js&"
export * from "./AdminQueueHealth.vue?vue&type=script&lang=js&"
import style0 from "./AdminQueueHealth.vue?vue&type=style&index=0&id=67f88278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f88278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f88278')) {
      api.createRecord('67f88278', component.options)
    } else {
      api.reload('67f88278', component.options)
    }
    module.hot.accept("./AdminQueueHealth.vue?vue&type=template&id=67f88278&scoped=true&", function () {
      api.rerender('67f88278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminQueueHealth.vue"
export default component.exports